import { ChangeDetectionStrategy, Component, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseConfigService } from '@fuse/services/config';
import { first } from 'rxjs';
import { storeScheme } from '@hmax-order/frontend/utils';

@Component({
  selector: 'hmax-color-scheme',
  standalone: true,
  templateUrl: './color-scheme.component.html',
  styleUrls: ['./color-scheme.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'hmaxColorScheme',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
})
export class ColorSchemeComponent implements OnInit {
  private _fuseConfigService = inject(FuseConfigService);

  @Input() tooltip!: string;
  @Input() scheme: 'dark' | 'light' = 'light';

  ngOnInit(): void {
    this._fuseConfigService.config$.pipe(first()).subscribe({
      next: ({ scheme }) => {
        if (scheme) {
          this.scheme = scheme;
        }
      },
    });
  }

  toggleScheme(): void {
    const scheme = this.scheme === 'light' ? (this.scheme = 'dark') : (this.scheme = 'light');
    this._fuseConfigService.config = { scheme };
    // Escolha explícita do usuário: grava para o F5 subir já neste tema. O `darkMode` do token é
    // só o padrão, e `AuthService.checkChangeTheme` cede a esta gravação.
    storeScheme(scheme);
  }
}
